import { render, staticRenderFns } from "./VeHrPerformanceRuleForm.vue?vue&type=template&id=5fddb012"
import script from "./VeHrPerformanceRuleForm.vue?vue&type=script&lang=js"
export * from "./VeHrPerformanceRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports